import React from 'react'

interface MaskProps {
  /**
   * The color of the mask
   * @default "#4B4A4A"
   */
  color?: string
  /**
   * The width of the mask
   * @default 231
   */
  width?: number
  /**
   * The height of the mask
   * @default 123
   */
  height?: number
  /**
   * Additional className for styling
   */
  className?: string
}

export const Mask: React.FC<MaskProps> = ({
  color = '#4B4A4A',
  width = 231,
  height = 123,
  className = '',
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 231 123"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M75.7403 32L85.4903 29.2L118.43 0L180.31 76.56L191.31 74.38L205 95.46L214.41 102.46L230.95 122.46H93.0003L95.8303 103.89L80.7003 64.84L86.5803 61.25L82.1303 41.72L89.8403 39.44L109.75 21.26L116.27 32.48L124.27 38.06L130.72 54.55L131.11 26.9L118.53 4.39L86.2803 33L77.5603 35.6L53.0903 49.3C53.0903 49.3 32.3303 63.58 31.2803 64.42C30.2303 65.26 12.9203 110.54 11.6803 113.26L7.48027 122.5H0.530273L28.1003 61.25L51.1003 45.8"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M74.3299 73.96L75.8399 77.42L69.8099 101.75L69.6999 122.5H60.4199L61.1599 102.06L74.3299 73.96Z"
        fill={color}
      />
    </svg>
  )
}
